export enum Environments {
  Local = 'local',
  Dev = 'dev',
  Preprod = 'preprod',
  Hotfix = 'hotfix',
  Prod = 'prod',
}
